(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nbd-dialog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nbd-dialog')) {
    customElements.define('nbd-dialog', class NBDDialog extends HTMLElement {
      static count = 0;

      constructor() {
        super();
        this.handleOpenClick = this.handleOpenClick.bind(this);
        this.handleDialogClick = this.handleDialogClick.bind(this);
      }

      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.labelDialog();
        const id = this.dataset.id;
        const selector = id
          ? `[data-nbd-open-dialog=""], [data-nbd-open-dialog="${CSS.escape(id)}"]`
          : '[data-nbd-open-dialog=""]';
        this.openButtons = document.querySelectorAll(selector);
        this.openButtons.forEach((button) => {
          button.setAttribute('aria-haspopup', 'dialog');
          button.addEventListener('click', this.handleOpenClick);
        });
        this.dialog.addEventListener('click', this.handleDialogClick);
      }

      disconnectedCallback() {
        this.openButtons.forEach((button) => button.removeEventListener('click', this.handleOpenClick));
        this.dialog.removeEventListener('click', this.handleDialogClick);
      }

      labelDialog() {
        const title = this.querySelector('.nbd-dialog-header-title');
        if (!title?.textContent.trim() || this.dialog.hasAttribute('aria-labelledby')) return;
        title.id ||= `nbd-dialog-title-${++NBDDialog.count}`;
        this.dialog.setAttribute('aria-labelledby', title.id);
      }

      handleOpenClick() {
        this.dialog.showModal();
      }

      handleDialogClick(event) {
        if (event.target.closest('[data-nbd-close-dialog]')) {
          this.dialog.close();
          return;
        }
        if (event.target !== this.dialog) return;
        // The dialog itself is the target for clicks on empty panel space too, so check the click landed outside the panel.
        const rect = this.dialog.getBoundingClientRect();
        const inside = event.clientX >= rect.left && event.clientX <= rect.right
          && event.clientY >= rect.top && event.clientY <= rect.bottom;
        if (!inside) this.dialog.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nbd-variant-labels"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nbd-variant-labels')) {
    // Keyed by window.Shopify.theme.schema_name, so the theme editor cannot break the placement.
    const THEME_PRESETS = {
      Dawn: { selector: '.product-form__input input[data-option-value-id="{id}"] + label' },
    };

    customElements.define('nbd-variant-labels', class NBDVariantLabels extends HTMLElement {
      connectedCallback() {
        const themeName = window.Shopify?.theme?.schema_name;
        const preset = THEME_PRESETS[themeName] || {};
        const siteConfig = window.NBD?.config?.variantLabels || {};
        this.selector = this.dataset.selector || siteConfig.selector || preset.selector;
        if (!this.selector) {
          console.info(`nbd-variant-labels: no preset for theme "${themeName}", no labels shown`);
          return;
        }
        try {
          this.labels = JSON.parse(this.querySelector('script').textContent);
        } catch (e) {
          return;
        }
        this.scope = this.closest('.shopify-section') || document.body;
        this.apply();
        // Themes replace their picker markup on variant change.
        this.observer = new MutationObserver(() => this.apply());
        this.observer.observe(this.scope, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      apply() {
        this.labels.forEach(({ id, label }) => {
          const target = this.scope.querySelector(this.selector.replace('{id}', CSS.escape(String(id))));
          if (!target || target.querySelector(':scope > .nbd-variant-label')) return;
          const span = document.createElement('span');
          span.className = `nbd-variant-label ${this.dataset.class || ''}`.trim();
          span.textContent = label;
          target.append(span);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
